<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
        <app-form-control [cid]="'title'" [control]="form.get('title')" [type]="'input'" [label]="t('common.labels.title_on_ac')"></app-form-control>
        <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')"></app-form-control>

        <div class="p-field-acr">
          <label>{{ t('common.labels.procedure_types') }}</label>
        </div>
        <div class="p-mb-2">
          <app-form-control [cid]="'for_single'" [control]="form.get('for_single')" [type]="'checkbox'" [label]="t('common.labels.for_single_procedures')" [noMargin]="true"></app-form-control>
        </div>
        <app-form-control [cid]="'for_group'" [control]="form.get('for_group')" [type]="'checkbox'" [label]="t('common.labels.for_group_procedures')" [noMargin]="true"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'description'" [control]="form.get('description')" [type]="'textarea'" [label]="t('common.labels.description')"></app-form-control>
      </div>
    </div>

    <ng-container *ngIf="hasGroupSettings() === true">

      <hr/>

      <h2>{{ t('common.labels.settings_for_group_procedures') }}</h2>

      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'type'" [control]="form.get('group_settings.type')" [type]="'select'" [options]="types" [label]="t('common.labels.exercisetype')"></app-form-control>
          <app-form-control [cid]="'min_observers_per_candidate'" [control]="form.get('group_settings.min_observers_per_candidate')" [type]="'input'" [label]="t('common.labels.min_observer_per_candidate')"></app-form-control>
          <app-form-control *ngIf="isTeam()" [cid]="'min_candidates_per_team'" [control]="form.get('group_settings.min_candidates_per_team')" [type]="'input'" [label]="t('common.labels.min_candidates_per_team')"></app-form-control>
          <app-form-control [cid]="'overlapping'" [control]="form.get('group_settings.overlapping')" [type]="'checkbox'" [label]="t('common.labels.exercise_overlapping')"></app-form-control>
        </div>
      </div>

    </ng-container>

  </form>
</ng-container>
